import HeaderBasic from 'components/Headers/Basic';
import {FC} from 'react';
import {useBackend} from 'state/backend';
import {Backend} from 'types/api';

import MagicLinkSuccess from '../components/MagicLinkSuccess';
import PortalPageLayout from '../components/PortalPageLayout';

export type PortalLoginSuccessBackend = Backend<{
    email: string;
}>;

const PortalLoginSuccess: FC = () => {
    const {data} = useBackend<PortalLoginSuccessBackend>();

    return (
        <PortalPageLayout isResponsive={true}>
            <HeaderBasic
                className="px-8 pb-2"
                dropdownLocaleSize="xs"
                showSignIn={false}
            />
            <div className="mx-8 rounded-lg border border-grey-300 bg-white px-6 pb-12 pt-6 shadow-lg">
                <MagicLinkSuccess emailAddress={data.email} />
            </div>
        </PortalPageLayout>
    );
};

export default PortalLoginSuccess;
